import React, { Children, useEffect, useState } from "react"
import { map, groupBy, orderBy, find } from "lodash"
import { createStructuredSelector } from "reselect"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { compose } from "redux"

// Actions
import { getBusinessUsersAction } from "Containers/BusinessInformations/actions"

// Selectors
import { selectBusinessUsers } from "Containers/BusinessInformations/selectors"

// Components

// Utils
import moment from "moment"
export const formatDateInIsoFormat = date => {
  return moment(date).toISOString()
}

import { transformDate } from "Components/MSF/utils"
import {
  handlePhaseCompletion,
  checkInfosStep,
  getTiming,
  addDays,
} from "Components/MSF/CaseFile/utils/utils"

// Style
import { WidgetContainer, ItemContainer } from "./index.style"

const CaseCardMSF = ({
  dispatchGetUsers,
  columnsLabelsMapping,
  primaryActionColor,
  listBusinessUsers,
  fieldsData,
  dataChart,
  valueData,
}) => {
  // ***************************** //
  //          Life Cycle           //
  // ***************************** //
  useEffect(() => {
    dispatchGetUsers()
  }, [])

  // Function
  const transformSourceDataInArrayData = (sourceData, sourceColumn) => {
    const source = sourceData || []
    const data = map(source, item => {
      let objectData = {}
      for (const [key, value] of Object.entries(item)) {
        objectData = {
          ...objectData,
          [getNameColumnUuid(sourceColumn, key)]: value,
        }
      }
      return objectData
    })
    return data
  }

  // Récupération le nom de la colonne par rapport à l'uuid
  const getNameColumnUuid = (sourceColumn, uuid) => {
    return sourceColumn?.find(col => col.valueId === uuid)?.label
  }

  // ***************************** //
  //           Constantes          //
  // ***************************** //
  const dataSource = transformSourceDataInArrayData(dataChart, columnsLabelsMapping)
  const dataSourceGroup = groupBy(dataSource, "idCase")
  const dataMapping = map(dataSourceGroup, item => {
    // console.log("item", item)
    const responseAffaire = orderBy(item, ["updated_at"], ["desc"])
    const phaseCompletion = handlePhaseCompletion(responseAffaire, fieldsData)
    const stepInfos = checkInfosStep(responseAffaire, phaseCompletion, listBusinessUsers)
    const getDateStartTiming = find(responseAffaire, { step: "dcs_reception_date" })
    const dateStartTiming = getDateStartTiming?.response
    const phaseDaysToAdd = stepInfos?.inProgressNameStep === "Analyse du besoin" ? 122 : 35
    const deadline = formatDateInIsoFormat(addDays(dateStartTiming, phaseDaysToAdd))

    return {
      step: stepInfos?.step,
      name: item[0]?.reference,
      inProgressNameStep: stepInfos?.inProgressNameStep,
      afterNameStep: stepInfos?.afterNameStep,
      deadline: transformDate(deadline),
      advancementStep: stepInfos?.advancementStep,
      responsableInProgressStep: stepInfos?.fullResponsableNameOne,
      responsableAfterStep: stepInfos?.fullResponsableNameTwo,
      phaseCompletion: phaseCompletion,
      item: item,
    }
  })
  const data = orderBy(dataMapping, ["created_date_affaire"], ["desc"])

  return (
    <WidgetContainer>
      {Children.toArray(
        data?.map(item => {
          return (
            <ItemContainer primaryActionColor={primaryActionColor}>
              <div className="reference">{item?.name}</div>
              <div className="etape_en_cours">{`Etape en cours: ${item?.inProgressNameStep}`}</div>
              {item?.responsableInProgressStep !== "" && (
                <div className="responsable">{`Responsable: ${item?.responsableInProgressStep}`}</div>
              )}
              <div className="deadline">{`Deadline: ${item?.deadline || ""}`}</div>
              <div className="phase">{`Phase ${item?.step}`}</div>
            </ItemContainer>
          )
        })
      )}
    </WidgetContainer>
  )
}

CaseCardMSF.propTypes = {}

CaseCardMSF.defaultProps = {}

const mapDispatchToProps = dispatch => ({
  dispatchGetUsers: core => dispatch(getBusinessUsersAction(core)),
})

const mapStateToProps = createStructuredSelector({
  listBusinessUsers: selectBusinessUsers,
})

export default compose(connect(mapStateToProps, mapDispatchToProps))(CaseCardMSF)
